import { useCallback, useMemo, useState } from "react";
import { Workspace } from "../../../../types/types";
import { WorkspaceLocalRepository } from "./repository/WorkspaceRepository";

const useWorkspace_Local = () => {
    const [workspaces, setWorkspaces] = useState<Workspace[]>([]);
    const [workspaceMap, setWorkspaceMap] = useState<Map<string, Workspace>>(new Map());
    const repository = useMemo(() => new WorkspaceLocalRepository(), []);

    const createWorkspace = async (): Promise<Workspace> => {
        const newWorkspace: Workspace = {
            id: crypto.randomUUID(),
            title: "New Workspace",
            lists: [],
            description: "",
            image: "",
        };

        await repository.save(newWorkspace);
        await refresh();
        return newWorkspace;
    };

    const getWorkspaces = useCallback(async (): Promise<Workspace[]> => {
        return repository.findAll();
    }, [repository]);

    const updateWorkspace = async (workspaceId: string, updates: Partial<Workspace>): Promise<Workspace> => {
        const workspace = workspaceMap.get(workspaceId);
        if (!workspace) {
            throw new Error("Workspace not found");
        }

        const updatedWorkspace = { ...workspace, ...updates };
        await repository.save(updatedWorkspace);
        await refresh();
        return updatedWorkspace;
    };

    const deleteWorkspace = async (workspaceId: string): Promise<boolean> => {
        await repository.delete(workspaceId);
        await refresh();
        return true;
    };

    const refresh = useCallback(async () => {
        try {
            const storedWorkspaces = await getWorkspaces();
            setWorkspaces(storedWorkspaces);
            setWorkspaceMap(new Map(storedWorkspaces.map(w => [w.id, w])));
        } catch (error) {
            // console.error("Error refreshing workspaces:");
        }
    }, [getWorkspaces]);

    return {
        refresh,
        workspaces,
        workspaceMap,
        createWorkspace,
        updateWorkspace,
        deleteWorkspace,
    }
}

export default useWorkspace_Local;